import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Note } from '@rocksoft/mdm-sdk-v2';

export function selectIdFromNote(note: Note) {
  return note?.id;
}

export const adapter: EntityAdapter<DeviceNote> = createEntityAdapter<DeviceNote>({
  selectId: selectIdFromNote,
});

export type NotesState = EntityState<DeviceNote>;

export interface DeviceNote extends Note {
  udid: string;
}

export const initialState: NotesState = adapter.getInitialState();
